import { Company, Goal, Period } from '../models';

export function updateGoalPeriod(
  company: Company,
  goalId: string,
  periodState: Period,
  periodId: string
): Goal[] {
  return (
    company.companyDetails?.goals.map((goalItem: Goal) => {
      // Check if the current goalItem is the goal we want to update
      if (goalItem._id === goalId) {
        // Find the index of the period
        const periodIndex = goalItem.periods.findIndex(
          (periodItem: Period) => periodItem._id === periodId
        );

        // If the period is found
        if (periodIndex !== -1) {
          // Create a copy of the periods array
          const updatedPeriods = [...goalItem.periods];
          // Update the specific period in the copied array
          updatedPeriods[periodIndex] = {
            ...periodState,
            _id: goalItem.periods[periodIndex]._id,
          };

          return {
            ...goalItem,
            periods: updatedPeriods,
          };
        }
      }
      return goalItem;
    }) ?? []
  );
}

export function formatDateStringToISO(dateString: string): string {
  const date = new Date(dateString).toISOString().split('T')[0];
  return date.split('-').reverse().join('/');
}
